module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2021-1.a403ee81.jpg";